/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-07-11
 */

import React, { useEffect, useState } from "react";
import { SpinnerLoading } from "../utils/SpinnerLoading";
import { ErrorMessage } from "../utils/ErrorMessage";
import { fetchRecords } from "../utils/AppUtil";
import { Link } from "react-router-dom";

class Yahrzeit {
    deceasedId: string;
    deceased: string;
    yahrzeitDateDisplay: string;
    yahrzeitDesc: string;
    constructor(deceasedId: string, deceased: string, yahrzeitDateDisplay: string, yahrzeitDesc: string) {
        this.deceasedId = deceasedId;
        this.deceased = deceased;
        this.yahrzeitDateDisplay = yahrzeitDateDisplay
        this.yahrzeitDesc = yahrzeitDesc
    }
}

type WeeklyYahrzeitProps = {
    endpoint: string;
    recordCount: number;
}

export const WeeklyYahrzeit: React.FC<WeeklyYahrzeitProps> = (props): JSX.Element => {

    const [records, setRecords] = useState<Yahrzeit[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [httpError, setHttpError] = useState(null);
    const [endpoint, setEndpoint] = useState(`${props.endpoint}?count=${props.recordCount}`);

    // Do not change this or put any additional code in here without checking with
    // the team first.
    useEffect(() => {

        fetchRecords(endpoint, processData)
        .catch((error) => {
            setIsLoading(false);
            setHttpError(error.message);
        });

    }, [endpoint]);

    // You may edit this function to manipulate the way your code is processed.
    const processData = (responseJson: any) => { // Do not edit these parameters, just the content of this function.
        const recordData: Yahrzeit[] = [];
    
        for(const key in responseJson) {
            const record: any = responseJson[key];
            const deceasedId = record["deceasedId"];

            let deceased: string = (record["firstName"] ? record["firstName"] : "") + " " + (record["lastName"] ? record["lastName"] : "");
            if(!record["deceasedId"]) {
                deceased = "Not Specified";
            }

            const yahrzeitDateDisplay: string = record["yahrzeitDateDisplay"];
            const yahrzeitDesc: string = record["yahrzeitDesc"];

            recordData.push(new Yahrzeit(deceasedId, deceased, yahrzeitDateDisplay, yahrzeitDesc));
            
        }
        setRecords(recordData);
        setIsLoading(false);
    }

    if(isLoading) {
        return(
            <SpinnerLoading />
        )
    }

    if(httpError) {
        return(
            <ErrorMessage error={httpError} />
        )
    }

    const result: React.ReactElement[] = [];

    records.forEach((weeklyYahrzeit, index) => {
        result.push(
            <tr key={index}>
                <td className="jc-txt-body fs-6 fw-bold table-mobile-left"><Link to={'/deceased/' + weeklyYahrzeit.deceasedId} className="jc-txt-blue">{weeklyYahrzeit.deceased}</Link></td>
                <td className="jc-txt-body fs-7 align-end table-mobile-right" style={{whiteSpace: "nowrap"}}>
                    <span>{weeklyYahrzeit.yahrzeitDateDisplay}</span>&nbsp;•&nbsp;
                    <span>{weeklyYahrzeit.yahrzeitDesc}</span>
                </td>
            </tr>
        )
    });
    
    return (
        <div className="card card-weekly-yahrzeit jc-border-12">
            <div className="card-header card-header-bg">
                <p className="jc-txt-heading fs-5">Upcoming Yahrzeits</p>
            </div>

            <div className="card-body p-0">
                <div className="table-weekly-yahrzeit">
                    <table className="table table-striped mb-0">
                        <tbody>
                            {result}
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    );
}